class RecommendedProduct extends HTMLElement {
  constructor() {
    super();
    const productRecommendationsSection = this.querySelector(
      ".recommended-product",
    );
    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then(async (text) => {
        var parser = new DOMParser();
        var doc = parser.parseFromString(text, "text/html");
        const recommendations = doc.querySelector(".recommended-product");

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          await this.loadInjectedScripts(productRecommendationsSection);
        }

        this.customRantings();

        this.recommendedList = this.querySelector(".recommended-list");
        this.getAllCards = this.querySelectorAll(
          ".product-card[data-recommended-card]",
        );
        this.getAllCardBtn = this.querySelectorAll(".product-card-btn");
        this.getAllVariantBtn = this.querySelectorAll(".product-card-add");
        this.navigation = this.querySelectorAll(
          ".recommended-navigation-button",
        );

        this.variantPicker = document.querySelector("variant-picker");

        let currentIndex = 0;
        this.recommendedList.scrollTo(0, 0);

        [...this.navigation].forEach((nav) => {
          nav.addEventListener("click", () => {
            currentIndex = this.currentPosition(nav, currentIndex);
            this.scrollList(this.recommendedList, nav, currentIndex);
          });
        });
        this.variantPicker.renderVariantPicker(this.getAllVariantBtn);
        this.variantPicker.addToCartDrawer();
        this.addToCartDrawer();
      });
  }

  // Scripts set via innerHTML are inert, so replace each one with a freshly
  // created node to make the browser execute it. Runs them in document order
  // and waits for external ones so later scripts can rely on them.
  async loadInjectedScripts(container) {
    const injectedScripts = [...container.querySelectorAll("script")];

    for (const injectedScript of injectedScripts) {
      const isExternal = Boolean(injectedScript.src);
      const alreadyOnPage =
        isExternal &&
        [...document.scripts].some(
          (script) =>
            script.src === injectedScript.src && !container.contains(script),
        );

      if (alreadyOnPage) {
        injectedScript.remove();
        continue;
      }

      const script = document.createElement("script");
      [...injectedScript.attributes].forEach((attribute) =>
        script.setAttribute(attribute.name, attribute.value),
      );
      script.textContent = injectedScript.textContent;

      const executed = isExternal
        ? new Promise((resolve) => {
            script.addEventListener("load", resolve, { once: true });
            script.addEventListener("error", resolve, { once: true });
          })
        : Promise.resolve();

      injectedScript.replaceWith(script);
      await executed;
    }
  }

  customRantings() {
    const getAllRatingsElements =
      document.querySelectorAll(".card-star-rating");
    getAllRatingsElements.forEach((ratingElement) => {
      globalCustomStartRating(ratingElement, ".yotpo-display-wrapper").then(
        (currentRating) => {
          let wrapper = document.createElement("div");
          let averageRating = document.createElement("span");
          let star = document.createElement("span");

          star.innerHTML = `<svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 1.5L7.545 4.63L11 5.135L8.5 7.57L9.09 11.01L6 9.385L2.91 11.01L3.5 7.57L1 5.135L4.455 4.63L6 1.5Z" fill="#FFCD3C" stroke="#FFCD3C" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`;

          averageRating.textContent = `
          ${parseFloat(currentRating.querySelector(".sr-only").textContent)}
          (${parseFloat(currentRating.querySelector(".text-m").textContent)})
    `;
          wrapper.className = "product-card-rating";
          wrapper.append(star, averageRating);
          ratingElement.append(wrapper);
        },
      );
    });
  }

  scrollList(recommendedList, nav, currentIndex) {
    let list = recommendedList;
    let size = this.getAllCards.length;
    let listWidth = Math.floor(list.scrollWidth);
    let cardWidth = Math.floor(listWidth / size);
    let difference = Math.floor(list.clientWidth / cardWidth);
    let direction = nav.getAttribute("data-switch-action");
    direction === "next"
      ? (list.scrollLeft = list.scrollLeft + cardWidth * 1)
      : (list.scrollLeft = list.scrollLeft - cardWidth * 1);

    this.visibilityNav(currentIndex, size, difference);
  }

  visibilityNav(currentIndex, size, difference) {
    let prev = this.navigation[0];
    let next = this.navigation[1];

    currentIndex === 0
      ? prev.setAttribute("data-active", "false")
      : prev.setAttribute("data-active", "true");

    currentIndex === size - difference
      ? next.setAttribute("data-active", "false")
      : next.setAttribute("data-active", "true");
  }

  currentPosition(nav, currentIndex) {
    return nav.getAttribute("data-switch-action") === "next"
      ? ++currentIndex
      : --currentIndex;
  }

  addToCartDrawer() {
    this.getAllCardBtn.forEach((btn) => {
      btn.addEventListener("click", () => {
        let id = parseInt(btn.getAttribute("data-product-id"));
        addToCartOpenDrawer(id, 1);
      });
    });
  }
}
customElements.define("recommended-product", RecommendedProduct);
